import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { reportSlice } from '@pwc/pwc-deals-report-ui';
import analysisSlice from '../features/analyses/analysisSlice';
import structuredDocumentDescriptionSlice from '../common/engine/reducers/structuredDocumentDescriptionSlice';
import { structuredAnalysisEditReducer } from '../features/analyses/structuredAnalysisEditSlice';
import { structuredAnalysisViewReducer } from '../common/engine/reducers/structuredAnalysisViewSlice';
import structuredAnalysisSlice from '../common/engine/reducers/StructuredAnalysisSlice';
import appSettings from '../features/appSettings/appSettingsSlice';
import commentsSlice from '../features/comments/commentsSlice';
import divestitureDiagnosticSlice from '../features/divestitureDiagnostic/divestitureDiagnosticSlice';
import hypothesisSlice from '../features/hypotheses/hypothesisSlice';
import insightSlice from '../features/insights/insightSlice';
import { insightsApi } from '../features/insights/insightsServiceNew';
import projectSlice from '../features/project/projectSlice';
import projectsSlice from '../features/projects/projectsSlice';
import projectDisclaimersSlice from '../features/projectDisclaimer/projectDisclaimerSlice';
import ProjectInitSlice from '../features/project/projectInitSlice';
import surveySlice from '../Survey/surveySlice';
import footerSlice from '../common/redux/termsAndConditions/footerSlice';
import reportFormatSlice from '../common/redux/reportFormat/reportFormatSlice';
import projectStatusChangeSlice from '../features/projectStateChangeCards/projectStatusChangeSlice';
import { projectOverviewReducer } from '../common/redux/project-overview/projectOverviewSlice';
import { getPowerBiReportsReducer } from '../features/analyses/getPowerBiReportsSlice';
import { getPowerBiReportReducer } from '../features/analyses/getPowerBiReportSlice';
import { editFreeformAnalysisReducer } from '../features/analyses/editFreeformAnalysisSlice';
import { savePowerBiReportReducer } from '../features/analyses/savePowerBiReportSlice';
import { getAnalysesReducer } from '../features/analyses/getAnalysesSlice';
import { getStructuredAnalysesDocumentsReducer } from '../features/analyses/getStructuredAnalysesDocumentsSlice';
import { pagedProjectsReducer } from '../features/projects/pagedProjectsSlice';
import adjustmentsByDocument from '../common/engine/reducers/adjustmentsByDocument';
import adjustmentSumsByDocument from '../common/engine/reducers/adjustmentSumsByDocument';
import adjustmentTogglesByDocument from '../common/engine/reducers/adjustmentTogglesByDocument';
import calcEngine from '../common/engine/reducers/calcEngine';
import factCalculations from '../common/engine/reducers/factCalculations';
import longDescription from '../common/engine/reducers/longDescription';
import timePeriodMetadataByDocument from '../common/engine/reducers/timePeriodMetadataByDocument';
import timePeriods from '../common/engine/reducers/timePeriods';
import toggledAdjustmentSumsByDocument from '../common/engine/reducers/toggledAdjustmentSumsByDocument';
import loggedInUserSlice from '../common/redux/security/loggedInUser/loggedInUserSlice';
import termsAndConditionsSlice from '../common/redux/termsAndConditions/termsAndConditionsSlice';
import userSettingsSlice from '../common/redux/userSettings/userSettingsSlice';
import userNotificationSettingsSlice from '../common/redux/userNotificationSettings/userNotificationSettingsSlice';
import userTermsAndConditionsSlice from '../common/redux/userTermsAndConditions/userTermsAndConditionsSlice';
import linkedAdjustmentsByDocument from '../common/engine/reducers/linkedAdjustmentsByDocument';
import errorsSlice from '../common/redux/errors/errorsSlice';
import { libraryItemsReducer } from '../features/analyses/libraryItemsSlice';
import powerPivotSlice from '../features/analyses/common/LibraryItemCard/PowerPivot/redux/powerPivotSlice';
import workflowSlice from '../common/redux/workflow/workflowSlice';

export const history = createBrowserHistory();

const commonReducers = {
  structuredAnalysis: structuredAnalysisSlice,
  loggedInUser: loggedInUserSlice,
  userTermsAndConditions: userTermsAndConditionsSlice,
  userSettings: userSettingsSlice,
  userNotificationSettings: userNotificationSettingsSlice,
  termsAndConditions: termsAndConditionsSlice,
  reportFormat: reportFormatSlice,
  footer: footerSlice,
  longDescriptionsByCode: longDescription,
  adjustmentsByDocument,
  adjustmentTogglesByDocument,
  adjustmentSumsByDocument,
  toggledAdjustmentSumsByDocument,
  factCalculations,
  timePeriodMetadataByDocument,
  timePeriodsByCode: timePeriods,
  calcEngine,
  linkedAdjustmentsByDocument,
  errors: errorsSlice,
  workflow: workflowSlice,
  projectOverview: projectOverviewReducer,
};

export const staticReducers = {
  router: connectRouter(history),
  project: projectSlice,
  projects: projectsSlice,
  projectInitConfig: ProjectInitSlice,
  structuredDocumentDescription: structuredDocumentDescriptionSlice,
  structuredAnalysisView: structuredAnalysisViewReducer,
  structuredAnalysisEdit: structuredAnalysisEditReducer,
  pagedProjects: pagedProjectsReducer,
  analysesList: getAnalysesReducer,
  structuredAnalysesDocuments: getStructuredAnalysesDocumentsReducer,
  getPowerBiReports: getPowerBiReportsReducer,
  getPowerBiReport: getPowerBiReportReducer,
  savePowerBiReport: savePowerBiReportReducer,
  editFreeformAnalysis: editFreeformAnalysisReducer,
  hypothesis: hypothesisSlice,
  insight: insightSlice,
  [insightsApi.reducerPath]: insightsApi.reducer,
  analysis: analysisSlice,
  comments: commentsSlice,
  report: reportSlice,
  projectDisclaimers: projectDisclaimersSlice,
  projectApprovals: projectStatusChangeSlice,
  appSettings,
  survey: surveySlice,
  divestitureDiagnostic: divestitureDiagnosticSlice,
  libraryItems: libraryItemsReducer,
  powerPivot: powerPivotSlice,
  ...commonReducers,
};
